import { useTranslation } from "react-i18next";
import { useState, useEffect, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import DelimiterInput from "../DelimiterInput";
import { treeActions } from "../../../redux/slices/treeSlice";
import GroupByName from "../GroupByName";
import TPCheckbox from "../TPCheckbox";
import { Stack } from "@mui/material";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import OverrideInboundDelimeter from "../OverrideInboundDelimeter";

export default function DelimitedFieldIdentifierForm() {
  const { t } = useTranslation();
  const parentScreen = useContext(ParentScreenCtx);
  const { rightTree } = useSelector((state) => state.treeData[parentScreen]);
  const dispatch = useDispatch();
  const [recordDelimiter, setRecordDelimiter] = useState(false);
  const [fieldDelimiter, setFieldDelimiter] = useState(false);
  const [groupSeparator, setGroupSeparator] = useState(":");
  const [stripQuotes, setStripQuotes] = useState(false);
  const [trimData, setTrimData] = useState(false);
  const [decodeData, setDecodeData] = useState(false);

  useEffect(() => {
    const header = rightTree.tree.templateHeader;
    setRecordDelimiter(header.LINEDELIMITER || '');
    setFieldDelimiter(header.DELIMITER || '');
    const groupSepValue = header?.GROUP_SEPARATOR || ":";
    setGroupSeparator(groupSepValue);
    
    // If GROUP_SEPARATOR doesn't exist in the header but we have a default, set it
    if (!header?.GROUP_SEPARATOR && groupSepValue === ":") {
      handleChange("GROUP_SEPARATOR", ":");
    }
    
    setStripQuotes(
      header.UNCSV
        ? (typeof header.UNCSV === "boolean" && header.UNCSV) ||
            header.UNCSV === "TRUE" ||
            false
        : false
    );
    setTrimData(
      header.TRIMDATA
        ? (typeof header.TRIMDATA === "boolean" && header.TRIMDATA) ||
            header.TRIMDATA === "TRUE" ||
            false
        : false
    );
    setDecodeData(
      header.URLDECODE
        ? (typeof header.URLDECODE === "boolean" && header.URLDECODE) ||
            header.URLDECODE === "TRUE" ||
            false
        : false
    );
    
  }, [rightTree.tree.templateHeader,t]);

  const handleChange = (key, value) => {
    dispatch(
      treeActions.setRightTreeTemplateHeaders({
        screen: parentScreen,
        key,
        value,
      })
    );
  };
  return (
    <>
      <>
        <DelimiterInput
          default
          label={t("LBL_REC_DELIM_")}
          value={recordDelimiter}
          name={"LINEDELIMITER"}
        />
        <DelimiterInput
          default
          label={t("LBL_FLD_DELIM")}
          value={fieldDelimiter}
          name={"DELIMITER"}
        />
        <DelimiterInput
          default
          label={t("LBL_GRP_DELIM")}
          value={groupSeparator}
          name={"GROUP_SEPARATOR"}
        />
      </>

      {parentScreen === "inbound" && (
        <>
          <div className="flex flex-wrap">
            <TPCheckbox
              label={t("BTN_STRIP_QUOTES")}
              checked={stripQuotes}
              handleCheck={(checked) => {
                setStripQuotes(checked);
                handleChange("UNCSV", checked);
              }}
            />
            <TPCheckbox
              label={t("BTN_TRIM_DATA")}
              checked={trimData}
              handleCheck={(checked) => {
                setTrimData(checked);
                handleChange("TRIMDATA", checked);
              }}
            />
            <TPCheckbox
              label={t("BTN_URLDECODE_DATA")}
              checked={decodeData}
              handleCheck={(checked) => {
                setDecodeData(checked);
                handleChange("URLDECODE", checked);
              }}
            />
          </div>
          <GroupByName />
        </>
      )}
      {parentScreen === "outbound" && (
        <OverrideInboundDelimeter/>
      )}
    </>
  );
}
